export default "__VITE_ASSET__CTFNcKRq__"